// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { Provenance } from '../../../bygning/provenance';
import styles from './Inspector.module.css';

/** Where a value came from (`bygning/provenance`): a small pill beside the control; warn for "mangler". */
export function ProvenanceTag({ tag }: { tag: Provenance | null | undefined }) {
  if (!tag) return null;
  return (
    <span className={tag.warn ? `${styles.ptag} ${styles.ptagWarn}` : styles.ptag} title="Hvor værdien kommer fra">
      {tag.label}
    </span>
  );
}
